<app-dealer-list-details [list]="list" [isShipTo]="isShipTo"></app-dealer-list-details>

<div
  ngbDropdown
  [ngClass]="['dealer-selection-container', setOneWord(isShipTo ? list.addressId : list.uid)]"
  [placement]="['bottom', 'top']"
  (openChange)="onOpenDropdown($event, isShipTo ? list.addressId : list.uid)"
>
  <button
    class="btn-link dealer-selection-dropdown"
    id="dealerSelectorDropdown"
    ngbDropdownToggle
    [disabled]="isDisabled(selected?.firstName, selected?.lastName, selected?.name, selected?.email) || disableDropdown"
  >
    <span class="dealer-selected">{{
      getSelectedName(selected?.firstName, selected?.lastName, selected?.name, selected?.email)
    }}</span>
    <mat-icon class="material-icons-sharp select-button" [class.rotated]="dropdownIsOpened">expand_more</mat-icon>
    <div ngbDropdownMenu class="dropdown-menu" aria-labelledby="dealerSelectorDropdown">
      <button
        ngbDropdownItem
        [class.selected]="user === selected"
        (click)="onCustomerSelection(user)"
        *ngFor="let user of getAllDealers(list?.administrators, list?.managers, list?.customers)"
      >
        <mat-icon svgIcon="check" class="selected-icon" *ngIf="user === selected"></mat-icon>
        {{ getSelectedName(user?.firstName, user?.lastName, user?.name, user?.email) }}
      </button>
    </div>
  </button>
</div>

<button
  class="btn btn-primary btn-block start-session"
  (click)="startImpersonate(list)"
  [disabled]="isStartBtnDisabled()"
>
  {{ 'dealer.start' | cxTranslate }}
</button>
